import { useQuery } from "react-query";
import {CrmBusinessLine, ProjectDtoListResult, ProjectService} from "../../../api/psc";
import useFetchQuery from "../../../hooks/useFetchQuery";
import { ProjectState } from "../slice/ProjectSlice";
import {useEffect, useState} from "react";

const fetchProjectsQueryFunction = async (
    defaultLimit: number,
    state: ProjectState
) =>
    ProjectService.filterProjects(
        "1",
        defaultLimit,
        state.page * defaultLimit,
        state.filter
    );

export const useFetchProjectsQuery = (
    defaultLimit: number,
    state: ProjectState
) =>
    useFetchQuery<ProjectDtoListResult>(() =>
        fetchProjectsQueryFunction(defaultLimit, state)
    );

export function useFetchProjects(defaultLimit: number, state: ProjectState) {
    return useQuery({
        queryKey: ["project-service"],
        queryFn: () =>
            ProjectService.filterProjects(
                "1",
                defaultLimit,
                state.page * defaultLimit,
                state.filter
            ),
    });
}

export function useFetchBusinessLines(){
    const [businessLines, setBusinessLines] = useState<CrmBusinessLine[]>([]);
    const [isLoadingBusinessLines, setIsLoadingBusinessLines] = useState<boolean>(true)

    useEffect(() => {
        fetchData().then()
    }, []);

    const fetchData = async () =>{
        setIsLoadingBusinessLines(true);
        const result = await ProjectService.listActiveListBusinessLines('1');
        setBusinessLines(result);
        setIsLoadingBusinessLines(false);
    }

    return {businessLines, isLoadingBusinessLines}
}
